import React, { useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { updateResumenProperty, setOfertas, updatePrice, clearGlobalDataAfterBuy, setCupon, setTransferenciaExitosa, setHayNbps} from '../../globalslice';
import { FaArrowRightLong, FaSpinner } from "react-icons/fa6";
import { Box } from '@mui/material';
import '../../styles/Resumen.scss';
import useWindowSize from '../hooks/useWindowSize';
import { fetchEvo, fetchSPEI, fetchPaypal, fetchNbps } from '../../services/PaymentManager'
import { addOrderPayPalPlus } from '../../services/Payments/PayPalPlus/addOrderPayPalPlus';
import { AuthContext } from '../../Auth';
import Swal from 'sweetalert2'
import SwipeBottom from '../Swipe/SwipeBottom';
import { useTranslation } from 'react-i18next';
import vector from "../../images/vector.svg";
import truswave from "../../images/logo-trustwave.png";
import { transformProducts } from '../../helpers/productHelper';
import { clearProfileDataAfterBuy, setAmount, setTotal } from '../../slices/profileSlice';
import Loader from '../Loader';
import getDomainPrices from '../../services/PriceDomain';
import { ErrorTransaction, ShowError } from '../../alerts/Error';
import loadEvoPaymentsScript from './loadEvoPaymentScript';
import { addOrderSaF } from '../../services/Payments/SAF/addOrderSaF';
import isProductWithHosting from '../../helpers/isProductWithHosting';
import calculatePriceDetails from '../../services/calculatePriceDetails';
import UpdatePriceChangeProfileDealer from './UpdatePriceChangeProfileDealer';
import eventosGTM from '../../helpers/eventsGTM';
import formatAmount from '../../helpers/formatAmount';
import Coupon from '../Checkout/Coupon';

function Resumen() {
  
  const resumenData = useSelector(state => state.global.ResumenData);
  const descuento = useSelector(state => state.global.descuento);
  const descuentoTotal = useSelector(state => state.global.descuentoTotal);
  const currency = useSelector(state => state.global.currency);
  const selectedOption = useSelector((state) => state.global.selectedOption);
  const location = useLocation();
  const isCheckout = location.pathname === '/checkout' || location.pathname === '/checkout/';
  const ResumenData = useSelector(state => state.global.ResumenData);
  const profile = useSelector(state => state.profile);
  const size = useWindowSize();
  const cupon = useSelector(state => state.global.cupon);
  const transferenciaExitosa = useSelector(state => state.global.transferenciaExitosa);
  const msg = useSelector(state => state.global.hayNbps);

  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalLocal, setTotalLocal] = useState(0);
  const [ivaLocal, setIvaLocal] = useState(0);
  const [subtotalLocal, setSubtotalLocal] = useState(0);
  const [currentNbps, setCurrentNbps] = useState(0);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  let descuentomostrar = 0;
  let botonResumen = null;
  
  const { userAuth } = useContext(AuthContext);
  const { t } = useTranslation();
  const { sendBeginCheckoutEvent, sendAddPaymentInfoEvent } = eventosGTM();

  //useEffect para actualizar el tamaño del resumen cuando llega el scroll al footer(tapaba el botón de comprar)
  const [height, setHeight] = useState("calc(100vh - 100px)");
  useEffect(() => {
    const resumen = document.querySelector(".resumen-content");
    const footer = document.querySelector(".cart-footer");

    const ajustarAltura = () => {
      const width = window.innerWidth;

      // Verificar si la pantalla es mayor a 786px (pantallas de escritorio)
      if (width > 786) {
        const footerRect = footer.getBoundingClientRect();

        if (footerRect.top < window.innerHeight) {
          // Calcular la nueva altura restando la distancia del footer al viewport
          const nuevaAltura = window.innerHeight - footerRect.top;
          setHeight(`calc(100vh - ${100 + nuevaAltura}px)`);
        } else {
          // Restaurar la altura original
          setHeight("calc(100vh - 100px)");
        }
        resumen.scrollTop = resumen.scrollHeight;

      } else {
        // Para pantallas móviles o pequeñas, mantener la altura original
        setHeight("calc(100vh - 100px)");
      }
    };

    window.addEventListener("scroll", ajustarAltura);
    window.addEventListener("resize", ajustarAltura);

    // Llamar a la función al montar el componente para manejar el caso inicial
    ajustarAltura();

    // Limpiar el event listener al desmontar el componente
    return () => {
      window.removeEventListener("scroll", ajustarAltura);
      window.removeEventListener("resize", ajustarAltura);
    };
  }, []);

  useEffect(() => {
    let subtotal = 0;
    resumenData.forEach((resumen) => {
      // Verificar si resumen.price.second_price existe y es una cadena
      const secondPrice = resumen.price && typeof resumen.price.second_price === "string" ? resumen.price.second_price.replace(/,/g, "") : 0; // Valor predeterminado en caso de que no sea una cadena

      if ((resumen.actual && !isCheckout) || (isCheckout && !resumen.actual) ) {
        subtotal += parseFloat(secondPrice);
      }

      if (resumen.product.privacy_protection && isCheckout) {
        let privacy_cost = resumen.price.privacy_cost;
        subtotal += parseFloat(privacy_cost);
      }
    });

    if (isCheckout) {
      descuentomostrar = descuentoTotal;
    } else {
      // resumenData.forEach((resumen) => {
      //   if (resumen.actual) {
      //     //SE DEBE SUMAR SOLO EL DESCUENTO DE LOS PRODUCTOS ACTUALES APLICABLES
      //   }
      // });
    }

    //Asigna valor del subtotal para mostrar u ocultar switch de nbps
    let total = subtotal - descuentomostrar;
    dispatch(setAmount(total));

    //resta los nbps si eligió la opción (switch parcial o pago total)
    if (profile.discount.nbps) {
      //pago parcial
      if (profile.nbps < total) {
        total = total - profile.nbps;
        setCurrentNbps(profile.nbps);
      } else {
        //pago total
        if (profile.nbps >= total) {
          setCurrentNbps(total);
          total = 0;
        }
      }
    }

    const iva = total * 0.16;
    if (total != 0) {
      total = total + iva;
    }

    // se agrega el total con IVA al profile reduce
    dispatch(setTotal(total));
    // subtotal, total e iva local
    setSubtotalLocal(subtotal);
    setTotalLocal(total);
    setIvaLocal(iva);
  }, [resumenData, profile, descuentoTotal]);


  const formatNumber = (number) => {
    return number.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

 // redirecciona a viewinvoice
 const redirectToErrorView = (invoiceId) => {
  const urlClientes = process.env.REACT_APP_CLIENTES_BASE_URL;
  window.location.replace(urlClientes + "viewinvoice.php?id=" + invoiceId + "&errortransfer=true");
};

  // reinicia valores después de crear orden
  const resetAfterCreateOrder = () => {
    dispatch(clearProfileDataAfterBuy());
    dispatch(clearGlobalDataAfterBuy());
    dispatch(setCupon(''));
  }

  const handleClickCheckout = () => {
    setLoading(true); // Set loading to true when button is clicked
    if (userAuth) {
      let paymentMethod = profile.paymentMethod
      
      // Envio de evento GTM
      sendAddPaymentInfoEvent(currency, ResumenData, cupon, paymentMethod, totalLocal, ivaLocal);

      navigate('/checkout/cart?a=complete', {
        state: {
          currencyState: currency,
          productsState: ResumenData,
          cuponState: cupon,
          paymentMethodState: paymentMethod,
          ivaLocalState: ivaLocal,
          totalLocalState: totalLocal
        },
      });
      
    } else {
      setLoading(false); 
      Swal.fire({
        title: 'Error!',
        text: 'Usuario no logueado. Por favor inicie sesión.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }
  };

  const handlePasoConfig = async () => {
    const abortController = new AbortController();
    let dominioCambiar, dominioCambiarid, dominioCambiarPeriod, costAgregar, domainType = null;
    let secondPriceAgregar, crossAgregar, selectPeriods, cross, selectPeriodsWithout= null;
    //sacamos dominios ya asignados a otro servicio que esten en actual false (es decir los que no estan sindo configurados)
    const assignedDomains = resumenData
      .filter((item) => item.product.domain_section && item.product.domain_section[0]?.dominio_principal && item.type!='domain' && item.actual === false )
      .map((item) => item.product.domain_section[0].dominio_principal);

    // Filtramos para obtener solo los dominios no asignados
    const availableDomains = resumenData
      .filter(
        (item) =>
          item.actual === false &&
          item.type === 'domain' &&
          item.product.domain_section &&
          !assignedDomains.includes(item.product.domain_section[0]?.dominio_principal)
      )
      .map((item) => item.product.domain_section[0]?.dominio_principal);
      
    //poner todos de .actual en false y pasar a checkout
    for (const resumen of resumenData) {
      if (resumen.actual) {
        // Actualiza la propiedad "actual" a false
        dispatch(updateResumenProperty({ id: resumen.id, property: "actual", value: false }));
        
        // Verifica si el tipo no es "domain" y el dominio principal está en availableDomains, hay que cambiar el precio de ese dominio
        if (
          resumen.type !== 'domain' &&
          resumen.product.domain_section &&
          availableDomains.includes(resumen.product.domain_section[0]?.dominio_principal)
        ) {
          const actualCambiar = resumenData.find(item => 
            item.type === 'domain' && 
            item.product.domain_section[0]?.dominio_principal === resumen.product.domain_section[0]?.dominio_principal
          );
          //modificar el precio del dominio
          if(actualCambiar.product.domain_section[0].domain_type == "transfer"){
            //Es dominio de transferencia, asi que modificamos el precio a transferencia con hosting 
            //Exceptuamos los productos con periodicidades no validas para dominio gratis
            if(isProductWithHosting(actualCambiar)){
              const domainPriceSin = await getDomainPrices({ domain: resumen.product.domain_section[0]?.dominio_principal, currency, type: "solo", typeDomainRegister: "transfer" }, abortController.signal);
              const domainPrice = await getDomainPrices({ domain: resumen.product.domain_section[0]?.dominio_principal, currency, type: "con", typeDomainRegister: "transfer", productId: resumen.pid },abortController.signal);
              const { newPrice } = calculatePriceDetails(domainPrice, domainPriceSin, 1);
              if (newPrice) {
                dispatch(updatePrice({ id: actualCambiar.id, newPrice }));
              }
            }
          }else {
            dominioCambiar = actualCambiar.product.domain_section[0]?.dominio_principal;
            dominioCambiarid = actualCambiar.id;
            dominioCambiarPeriod = parseInt(actualCambiar.periodo.match(/\d+/)[0], 10);
            domainType = actualCambiar.product.domain_section[0]?.domain_type;
          }
        }
      }
    }

    if(dominioCambiar != null){
      const domainPrice = await getDomainPrices({ domain: dominioCambiar, currency, type: 'con', typeDomainRegister: domainType }, abortController.signal);
      const domainPriceSin = await getDomainPrices({ domain: dominioCambiar, currency, type: 'solo', typeDomainRegister: domainType }, abortController.signal);

      if(domainPrice.precio[dominioCambiarPeriod-1].costo == 0 && domainPrice.precio[dominioCambiarPeriod-1].preciomostrado == 0){
        costAgregar = domainPriceSin.precio[dominioCambiarPeriod-1].preciomostrado ;
        secondPriceAgregar = domainPrice.precio[dominioCambiarPeriod-1].preciomostrado;
        crossAgregar = true;
      } else if (domainPrice.precio[dominioCambiarPeriod-1].tachado) {
        costAgregar = domainPrice.precio[dominioCambiarPeriod-1].preciomostrado ;
        secondPriceAgregar = domainPrice.precio[dominioCambiarPeriod-1].costo;
        crossAgregar = domainPrice.precio[dominioCambiarPeriod-1].tachado;
      } else if (domainPrice.precio[dominioCambiarPeriod-1].costo && domainPrice.precio[dominioCambiarPeriod-1].preciomostrado){
        costAgregar = domainPrice.precio[dominioCambiarPeriod-1].costo ;
        secondPriceAgregar = domainPrice.precio[dominioCambiarPeriod-1].preciomostrado;
        crossAgregar = false;
      } else {
        costAgregar = domainPrice.precio[dominioCambiarPeriod-1].costo ;
        secondPriceAgregar = domainPrice.precio[dominioCambiarPeriod-1].preciomostrado;
        crossAgregar = true;
      }

      selectPeriods = domainPrice.precio.reduce((acc, period) => {
        cross = period.costo != period.preciomostrado ? true : false;
        acc[period.periodo] = {
          cost: period.preciomostrado,
          cross_price: cross,
          second_price: period.costo
        };
        return acc;
      }, {});

      selectPeriodsWithout = domainPriceSin.precio.reduce((acc, period) => {
        cross = period.costo != period.preciomostrado ? true : false;
        acc[period.periodo] = {
          cost: period.preciomostrado,
          cross_price: cross,
          second_price: period.costo
        };
        return acc;
      }, {});
      let  newPrice = {
        cost: costAgregar,
        cross_price: crossAgregar,
        second_price: secondPriceAgregar
      };

      dispatch(updatePrice({ id: dominioCambiarid, newPrice }));
      dispatch(updateResumenProperty({ id: dominioCambiarid, property:"selectPeriods", value: selectPeriods }));
      dispatch(updateResumenProperty({ id: dominioCambiarid, property:"selectPeriodsWithout", value: selectPeriodsWithout }));
    }
    
    // Envio de evento GTM
    sendBeginCheckoutEvent(currency, ResumenData, cupon, totalLocal);

    navigate('/checkout');
  };

  if(!isCheckout){
    //es configuracion
    let hayNbps = false;
    botonResumen = 'config-false';
    resumenData.forEach(resumen => {
      if(resumen.type == 'nbps'){
        hayNbps = true;
        dispatch(setHayNbps('nbpsT'));
        navigate('/checkout');
      }
      if(resumen.actual && resumen.type != 'domain'){
        if(resumen.product.domain_section[0].dominio_principal != null){
          botonResumen = 'config-true';
        }
        if(resumen.type == 'nbps' && resumenData.length == 1){
          botonResumen = 'config-true';
          hayNbps = false;
          handlePasoConfig()  
        } else if(resumen.type == 'nbps' && resumenData.length > 1){
          dispatch(setHayNbps('nbps'));
          navigate('/checkout');
        }
      } else {
        //Transferencia de dominio sola desde v4
        if(resumen.actual && resumen.product.domain_section[0].domain_type == 'transfer') {
          //Activa el botón de 'Agregar al carrito'
          botonResumen = 'config-true';
        }
      }
    });
  } else {
    //es checkout
    if(userAuth && profile.paymentMethod != '') {
      botonResumen = "checkout-true";
    } else {
      botonResumen = "checkout-false";
    }
  }
  
  const getButtonProps = (botonResumen) => {
    switch (botonResumen) {
      case 'config-false':
        return { text: 'Agregar al Carrito', className: 'btn-grey', disabled: true, onClick: null };
      case 'config-true':
        return { text: 'Agregar al Carrito', className: 'btn-green', disabled: false, onClick: handlePasoConfig };
      case 'checkout-false':
        return { text: 'Listo para pagar', className: 'btn-grey', disabled: true, onClick: null };
      case 'checkout-true':
        return { text: 'Listo para pagar', className: 'btn-green', disabled: false, onClick: handleClickCheckout };
      default:
        return { text: '', className: '', disabled: true, onClick: null };
    }
  };

  const handleSwitchChange = (e) => {
    const isChecked = e.target.checked;
    dispatch(setOfertas(isChecked));
  };
  
  const renderResumen = () => (
    <>
      <div className="">
        <div className="res-title">{t('resumen.header.title')}</div>
        <div className="row res-resultados">
          {resumenData.filter(item => (isCheckout ? !item.actual : item.actual)).map((resultado) => (
            <div key={resultado.id} className="res-resultados-content">
              <div  className="res-title-price">
                <div className="res-titlep">
                  {resultado.product.smallname} {resultado.type !== 'nbps' ? `- ${resultado.periodo}` : '- Compra única'}
                </div>
                <div className="res-price">
                  {resultado.price.cross_price && resultado.price.cost !== null && resultado.price.cost !== '' && 
                    <span className="res-price-cross nobreak-word">$ {resultado.price.cost} {currency}</span>
                  }
                  <span className='nobreak-word'>$ {formatAmount(resultado.price.second_price)} {currency}</span>
                </div>
              </div>
              {resultado.type !== 'domain' && 
                resultado.product.domain_section && 
                resultado.product.domain_section.length > 0 &&
                resultado.type != 'nbps' && (
                  <div className="res-descripciones"> 
                    {resultado.product.domain_section.map((domain, index2) => (
                        <div key={`${resultado.id}-${index2}`}>
                          {domain.dominio_principal ?(
                            <span style={{ display: 'inline-flex' }}>
                              <span className='green-color' style={{ marginRight: 4 }}>»</span> {domain.dominio_principal}
                            </span>
                          ) : (
                            <span  style={{ display: 'inline-flex' }}>
                              <span className='green-color' style={{ marginRight: 4 }}>»</span> {t('resumen.content.nodomain')}
                            </span>
                          )}
                          <br></br>
                          { domain.so &&
                            <span  style={{ display: 'inline-flex' }}>
                              <span className='green-color' style={{ marginRight: 4 }}>»</span> {domain.so}
                            </span>
                          }
                          <br></br>
                          {domain.panel_admin &&
                            <span  style={{ display: 'inline-flex' }}>
                              <span className='green-color' style={{ marginRight: 4 }}>»</span> {domain.panel_admin}
                            </span>
                          }
                          {domain.promo &&
                            <span  style={{ display: 'inline-flex' }}>
                              <span className='green-color' style={{ marginRight: 4 }}>»</span> 
                              Más Promoción: 
                              <span className="res-descripciones-promo">{domain.promo}</span>
                            </span>
                          }
                        </div>
                    ))}
                  </div>
              )}
              {resultado.type === 'domain' && 
                resultado.product.domain_section && 
                resultado.product.domain_section.length > 0 && (
                  <div>                  
                    {resultado.product.domain_section.map((domain, index3) => {
                      const domainKeys = Object.keys(domain);
                      if (domainKeys.length === 0) {
                        return null;
                      }
                      const domainKey = domainKeys[0]; 

                      return (
                        <div key={`${resultado.id}-${index3}`} className="res-descripciones">
                          <div className="res-title-price">
                            <span style={{ display: 'inline-flex' }}><span className='green-color' style={{ marginRight: 4 }}>»</span> {domain[domainKey]}</span>
                            {
                              //Transferencia de dominio gratis CON hosting
                            resultado.price.cross_price && resultado.product.name === 'Transferencia de Dominio' ? (
                              <span className="res-descripciones-orange">{t('resumen.content.gratis')}</span>
                              //Transferencia de dominio sola
                            ) : resultado.price.cost == 0 && !resultado.price.cross_price && resultado.product.name === 'Transferencia de Dominio' ? (
                              null
                               //Dominios gratis con hosting
                            ) : resultado.price.cross_price ?
                              <span className="res-descripciones-orange">{t('resumen.content.gratish')}</span>
                            :
                            //Dominios sin Hosting(precio normal)
                            null
                            }
                          </div>
                        </div>
                      );
                    })}
                    {isCheckout && resultado.product.privacy_protection &&
                      <div className="res-descripciones">
                        <div className="res-title-price">
                          <span><span className='green-color'>»</span> {t('resumen.content.privacidad')}</span>
                          <span className="res-price">${resultado.price.privacy_cost} {currency}</span>
                        </div>
                      </div>
                    }
                </div>
              )}
              {location.pathname === '/checkout'  && msg !== 'nbpsT' && (
                <div className="res-separador"></div>
              )}
            </div>
          ))}
          {location.pathname === '/checkout'  && msg !== 'nbpsT' && (
            <Coupon />
          )}

          <div className="res-content-total">
            <div className="res-separador"></div>
            <div className="res-title-price res-subtotal-padding">
              <div className="res-total-txt">Subtotal</div>
              <div className="res-total">${formatNumber(subtotalLocal)} {currency}</div>
            </div>
            {descuentoTotal > 0 && location.pathname === '/checkout' &&
              <div className="res-title-price">
                <div className="res-total-txt">{t('resumen.content.descuento')}</div>
                <div className="res-total"><span className="descuento-txt">Promo<b> {descuento}</b></span>&nbsp;&nbsp;-${formatNumber(descuentoTotal)} {currency}</div>
              </div>
            }
            {//Muestra el descuento de los nbxpoints
            profile.discount.nbps === true &&
              <div className="res-title-price">
                <div className="res-total-txt">{t('resumen.content.nbxPoints')}</div>
                <div className="res-total"><span className="descuento-txt">  <b> {profile.nbps} points</b></span>&nbsp;&nbsp;-${formatNumber(currentNbps)} {currency}</div>
              </div>
            }
            {//Muestra el iva siempre y cuando se pague algo
            totalLocal > 0 &&
             <div className="res-title-price">
              <div className="res-total-txt"> IVA @ 16.00%</div>
              <div className="res-total">${formatNumber(ivaLocal)} {currency}</div>
            </div>
            }
            <div className="res-separador"></div>
          </div>
          <div className="res-title-price">
            <div className="res-total-total">Total</div>
            <div className="res-total-total">${formatNumber(totalLocal)} {currency}</div>
          </div>
          {location.pathname === '/checkout' && !userAuth && (
            <div className='ofertas'>
              <div className='ofertas-box'>
                <label className="switch">
                  <input type="checkbox" id="ofertaP" onChange={handleSwitchChange}  />
                  <span className="slider"></span>
                </label>
                <span className='ofertas-content'>{t('resumen.content.optin1')}<br></br> 
                  <span className='ofertas-content-light'>
                    {t('resumen.content.optin2')}<br></br>
                    {t('resumen.content.optin3')}
                  </span>
                </span>
              </div>
            </div>
          )}
          <div className='text-center button-content'>
            <button 
              className={`btn-comprar ${getButtonProps(botonResumen).className}`}
              disabled={getButtonProps(botonResumen).disabled || loading}
              onClick={getButtonProps(botonResumen).onClick}
            >
            {loading ? (
              <FaSpinner className="spinner" /> // Add spinner during loading
            ) : (
              <>
                {getButtonProps(botonResumen).text} <FaArrowRightLong />
              </>
            )}
            </button>
            <div className="politicas-content">Al continuar tu compra, aceptas nuestras <a href='https://neubox.com/politicas-de-servicio' target='_blank'>Políticas de Servicio</a>  así como el tratamiento de tus datos de acuerdo a nuestro <a href="https://neubox.com/aviso-de-privacidad" target='_blank'>Aviso de Privacidad.</a></div>
          </div>
          <div className='protegidas-content'>
            <img className="imgProteccion" src={vector} alt="cPanel"  style={{maxHeight: '15px', marginTop: '5px'}} />
            {t('resumen.content.protegidas')}
            <img className="imgProteccion" src={truswave} alt="cPanel"  style={{maxHeight: '10px', marginTop: '6px'}} />
          </div>
        </div>
        </div>
    </>
  );

  const showPaymentPage = () => {
    window.Checkout.showPaymentPage();
};

  const renderResumenClosed = () => (
    <Box sx={{ textAlign: 'center', pt: 1 }} className="totales-resultado">
      <div className="res-title-price res-totales">
        <div className="res-total">Total</div>
        <div className="res-total">${formatNumber(totalLocal)} {currency}</div>
      </div>
      <div className='text-center res-totales button-content'>
      <button 
          className={`btn-res-mobile ${getButtonProps(botonResumen).className}`}
          disabled={getButtonProps(botonResumen).disabled || loading}
          onClick={getButtonProps(botonResumen).onClick}
        >
        {loading ? (
          <FaSpinner className="spinner" /> // Add spinner during loading
        ) : (
          <>
            {getButtonProps(botonResumen).text} <FaArrowRightLong />
          </>
        )}
      </button>
      </div>
    </Box>
  );

  useEffect(() => {
    if (transferenciaExitosa) {
      handlePasoConfig(); // Ejecuta la función cuando el estado cambie
      dispatch(setTransferenciaExitosa(false)); 
    }
  }, [transferenciaExitosa]);

  return (
    <>
      <UpdatePriceChangeProfileDealer />
     <Loader open={loader} />
        {size.width < 768 ? (
          <SwipeBottom summaryClosed={renderResumenClosed()} className="content-resumen">
            {renderResumen()}
          </SwipeBottom>
        ) : (
          <div className="col-md-5 resumen-content" style={{height}}>  
          {renderResumen()}
          </div>
        )}
    </>
  );
}

export default Resumen;
